// extracted by mini-css-extract-plugin
module.exports = {"container":"e_nB","question":"e_oB","button":"e_pB","buttonNegative":"e_qB","buttonPositive":"e_rB","icon":"e_sB","iconNegative":"e_tB","iconPositive":"e_uB"};